import React from 'react';
import { compose } from 'recompose';
import { Flex, Button, Div, Span, LightText, PlaneIcon } from './hocs/withStyles';

const Airfare = compose()(
  ({
    departureDate,
    name: destName,
    iataCode,
    origin,
    originName,
    returnDate,
    goToSkyscanner,
    distance,
    quote
  }) => {
    return (
      <Flex direction="column" justifyContent="space-between" width="100%">
        <Flex m={[0, 0, 1, 0]}>
          <h4>Travel Info</h4>
        </Flex>
        <Div m={[1, 0, 2, 0]}>
          <Span>
            {originName} (<strong>{origin}</strong>){' '}
          </Span>
          round-trip to
          <Span>
            {' '}
            {destName} (<strong>{iataCode}</strong>)
          </Span>
          {distance && (
            <LightText p={[0, 1]} fontSize="0.9em">
              {' '}
              {distance}km
            </LightText>
          )}
        </Div>
        <Flex
          p={[1, 0, 0, 0]}
          width="100%"
          css={{
            flexDirection: 'row',
            '@media (orientation: portrait)': {
              flexDirection: 'row-reverse'
            }
          }}
        >
          <Button p={[2]} onClick={goToSkyscanner}>
            <PlaneIcon color="white" css={{ fontSize: '18px', marginRight: '3px' }} />{' '}
            <Span color="white">
              {quote.isDirect ? 'direct' : ''} flights for{' '}
              <Span color="white" css={{ fontSize: '18px' }}>
                {quote.currency}
                {quote.price}
              </Span>
            </Span>
          </Button>
        </Flex>
      </Flex>
    );
  }
);

export default Airfare;



// WEBPACK FOOTER //
// ./src/components/Airfare.js